/**
 * Popular Courses Carousel - Swiper.js Implementation
 * Infinite loop carousel with pagination dots
 */

document.addEventListener('DOMContentLoaded', function () {
  initPopularCoursesSwiper();
});

function initPopularCoursesSwiper() {
  const swiperContainers = document.querySelectorAll('.popular-courses__swiper');

  if (!swiperContainers.length || typeof Swiper === 'undefined') {
    // If Swiper is not loaded yet, retry after a short delay
    if (swiperContainers.length && typeof Swiper === 'undefined') {
      setTimeout(initPopularCoursesSwiper, 100);
    }
    return;
  }

  swiperContainers.forEach(function (container) {
    new Swiper(container, {
      // Core settings
      effect: 'slide',
      grabCursor: true,
      loopAdditionalSlides: 2,

      // Speed and easing
      speed: 500,

      // Slides per view
      slidesPerView: 4,
      spaceBetween: 24,

      // Pagination dots
      pagination: {
        el: container.querySelector('.popular-courses__pagination'),
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },

      // Keyboard navigation
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      // Responsive breakpoints
      breakpoints: {
        // Extra small mobile
        0: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        // Mobile
        481: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        // Tablet
        769: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        // Desktop
        1200: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },

      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous product',
        nextSlideMessage: 'Next product',
      },
    });
  });
}
